import React, { FC, useEffect } from 'react';
import { buyerSettingsRestCrudThunksForBuyer } from '../../thunks/buyer_settings_thunks';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import { Route, Redirect } from 'react-router-dom';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';

const BuyerNotificationActions: FC<any> = ({
	match,
	getBuyerSettings,
	currentUser,
	buyerSettingsFetching,
	childRoutes,
}): React.ReactElement => {
	useEffect(() => {
		getBuyerSettings(encodeURIComponent(currentUser.email));
	}, []);

	const notificationType = match.params.notificationType;

	return buyerSettingsFetching ? (
		<PageLoadingPlaceholder />
	) : (
		<div>
			<Route
				path={`/buyer/notifications/${notificationType}`}
				exact={true}
				render={(props) => (
					<Redirect
						to={{
							pathname: `/buyer/notifications/${notificationType}/unsubscribe`,
						}}
					/>
				)}
			/>
			{childRoutes.map((r, i) => (
				<RouteWithSubRoutes key={i} {...r} />
			))}
		</div>
	);
};

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,

	buyerSettings: state.buyer_settings.detail,
	buyerSettingsFetching: state.buyer_settings.fetching,
});

const mapDispatchToProps = (dispatch) => ({
	getBuyerSettings: (email) => dispatch(buyerSettingsRestCrudThunksForBuyer.readOne(email)),
});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(BuyerNotificationActions)
);
